import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowRight } from "lucide-react";
import { Stars } from "./Stars";
import { Reveal, SectionHeading } from "./Reveal";
import { useLang } from "../i18n/LanguageContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ReviewsPreview() {
  const [top, setTop] = useState([]);
  const { t, lang } = useLang();

  useEffect(() => {
    axios
      .get(`${API}/reviews`)
      .then(({ data }) => {
        const sorted = [...data].sort((a, b) => b.stelle - a.stelle || new Date(b.created_at) - new Date(a.created_at));
        setTop(sorted.slice(0, 3));
      })
      .catch(() => {});
  }, []);

  if (top.length === 0) return null;

  return (
    <section className="bg-white py-24 sm:py-32" data-testid="reviews-preview-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading
          overline={t.home.reviewsOverline}
          title={t.home.reviewsTitle}
          desc={t.home.reviewsDesc}
        />

        <div className="mt-14 grid gap-5 md:grid-cols-3" data-testid="reviews-preview-grid">
          {top.map((r, i) => (
            <Reveal key={r.id} delay={i * 0.1}>
              <article className="flex h-full flex-col rounded-2xl border border-line bg-surface2/50 p-7 shadow-sm transition-[transform,box-shadow] duration-300 hover:-translate-y-1.5 hover:shadow-xl hover:shadow-slate-900/5" data-testid={`home-review-${r.id}`}>
                <Stars value={r.stelle} size={18} />
                <p className="mt-4 flex-1 text-sm leading-relaxed text-slate-600">"{r.commento}"</p>
                <div className="mt-6 flex items-center gap-3 border-t border-line pt-5">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-brand/10 font-heading text-sm font-bold text-brand">
                    {r.nome.charAt(0).toUpperCase()}
                  </span>
                  <div>
                    <p className="font-heading text-sm font-semibold text-slate-900">{r.nome}</p>
                    <p className="text-xs text-slate-400">
                      {new Date(r.created_at).toLocaleDateString(lang === "it" ? "it-IT" : "en-GB", { day: "numeric", month: "long", year: "numeric" })}
                    </p>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2} className="mt-10 text-center">
          <Link
            to="/recensioni"
            data-testid="reviews-view-all"
            className="group inline-flex items-center gap-2 rounded-full border border-slate-300 bg-white px-7 py-3.5 text-sm font-semibold text-slate-800 transition-colors duration-300 hover:border-brand hover:text-brand"
          >
            {t.home.reviewsAll}
            <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
